var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"color":_vm.primary ? 'primary' : 'secondary',"loading":_vm.loading,"disabled":_vm.loading,"small":_vm.small},on:{"click":_vm.handleGetAuthCode}},[_vm._v(" Login in new app ")])}
var staticRenderFns = []

export { render, staticRenderFns }